import CrossError from '../icons/crossError/CrossError';
import UrbaneaseLink from '../urbaneaseLink/UrbaneaseLink';
import styles from './messageError.module.scss';

interface IMessageErrorProps {
  errorType: Display;
}
function MessageError({ errorType }: IMessageErrorProps) {
  if (errorType !== 'postError' && errorType !== 'queryError') return null;

  return (
    <div className={styles.postError}>
      <CrossError />
      {errorType === 'postError' ? (
        <p>
          Les données d&apos;identification que vous avez fournies pour réinitialiser
          votre mot de passe ne sont pas valides. <br /> Il est possible que votre
          session ait expiré. <br />
          Si vous rencontrez toujours des problèmes, n&apos;hésitez pas à contacter
          le support d&apos;Urbanease.
        </p>
      ) : null}
      {errorType === 'queryError' ? (
        <p>
          Le lien utilisé pour la génération d&apos;un nouveau mot de passe ne
          fournit pas les paramètres nécessaires pour la réinitialisation de ce
          dernier. <br /> Veuillez renouveler la demande de réinitalisation. <br />
          Si vous rencontrez toujours des problèmes, n&apos;hésitez pas à contacter
          le support d&apos;Urbanease.
        </p>
      ) : null}
      <p>
        <a href="mailto:support@urbanease.io" className={styles.supportLink}>
          Contacter Urbanease
        </a>

        <UrbaneaseLink />
      </p>
    </div>
  );
}

export default MessageError;
